import React from 'react'

export default function Container12() {
  return (
    <div className='container-fluid py-3 cont12 '>
      <div className='container'>
        <div className='row '>
        <div className='col-lg-4 col-md-6 col-sm-12 f1 px-5'>
            <p className='text-white'><a href='http://piiscreen.de/datenschutzerklaerung' className='flinktext text-white'>Datenschutzerklärung</a> <span></span><a href='http://piiscreen.de/agb' className='flinktext text-white'>AGB</a><span></span><a href='http://piiscreen.de/impressum-footer' className='flinktext text-white'> Impressum</a> </p>
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12 text-center f2 px-5'>
            <p className='text-white'>© PiiScreen 2023<br/>
            <a href='https://www.peweo.com/' className='flinktext text-white'>Designed By PEWEO</a>
            </p>
        </div>
        <div className='col-lg-4 col-md-6 col-sm-12 text-end f3  pe-5 '>
       
    <p class="mx-2 fs-5"><a title="Facebook" className='footer-a mx-0' href="https://www.facebook.com/piiscreen.de" target="_blank" rel="noopener"><i class="fab fa-facebook-f"></i></a></p>
    <p class="mx-2 fs-5"><a title="LinkedIn" className='footer-a mx-0' href="https://www.linkedin.com/company/pii-screen/" target="_blank" rel="noopener"><i class="fab fa-linkedin-in"></i></a></p>
    <p class=" mx-2 fs-5"><a title="YouTube" className='footer-a mx-0' href="https://www.youtube.com/@piiscreen159" target="_blank" rel="noopener"><i class="fab fa-youtube"></i></a></p>
    <p class=" mx-2 fs-5"><a title="Instagram" className='footer-a mx-0' href="https://www.instagram.com/pii_screen_werbenetzwerk/" target="_blank" rel="noopener"><i class="fab fa-instagram"></i></a></p>
    
        </div>
        </div>
        </div>
    </div>
  )
}
